import { Navigate, useLocation, Outlet } from 'react-router-dom'
import { useAuth } from './AuthContext'
import { ChangePasswordModal } from './ChangePasswordModal'

export function AuthGuard() {
  const { user, loading } = useAuth()
  const location = useLocation()

  if (loading) {
    return (
      <div className="flex h-screen w-screen items-center justify-center bg-slate-50">
        <div className="flex flex-col items-center gap-3">
          <div className="h-8 w-8 animate-spin rounded-full border-2 border-emerald-800 border-t-transparent" />
          <div className="text-xs font-medium text-slate-500">Đang kiểm tra phiên đăng nhập...</div>
        </div>
      </div>
    )
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  return (
    <>
      <Outlet />
      {user.mustChangePassword && <ChangePasswordModal forcedOpen />}
    </>
  )
}
